import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import { deleteLocation, getLocations, getLocationById } from "../api/apiLocation";
import CreateOrUpdateLocation from "./CreateOrUpdateLocation";
import ConfirmationDialog from "common/components/ConfirmationDialog";

class Locations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            isOpen: false,
            selectedClient: null,
            locations: [],
            locationToEdit: null,
            locationToDelete: null,
            dialogOpen: false,
            isLoading: true,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getLocations(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getLocations(this.state.activePage, this.state.selectedClient.id))
    };

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getLocations(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getLocations = (page, selectedClient) => {
        getLocations({ params: { page: page, size: this.state.rowsPerPage } }, selectedClient).then((response) => {
            this.setState({
                locations: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getLocations(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getLocationById = (id) => {
        getLocationById(id).then(response => {
            this.setState({ locationToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_location_by_id"), { variant: 'error' });
        });
    }

    deleteLocation = () => {
        let { locationToDelete } = this.state
        deleteLocation(locationToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_location", { address: this.state.locationToDelete.address }), { variant: 'success' });
            this.setState({ dialogOpen: false, locationToDelete: null, rowsPerPage: this.state.rowsPerPage}, () => this.getLocations(0, this.state.selectedClient.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_location"), { variant: 'error' });
        });
    }

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getLocations(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    closeDialog = () => {
        this.setState({ isOpen: false, locationToEdit: null });
    }

    render() {

        let { locations, isOpen, specificsClients, isLoading, selectedClient, locationToEdit, locationToDelete, dialogOpen } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let locationsList;
        let recordsNotFound;
        if (locations && locations.length > 0) {
            locationsList = locations.map((location, index) => {
                return <TableRow key={index}>
                    <TableCell>{location.address}</TableCell>
                    <TableCell>{location.postalCode}</TableCell>
                    <TableCell>{location.city}</TableCell>
                    <TableCell>{location.country}</TableCell>
                    <TableCell>{location.floor}</TableCell>
                    <TableCell>{location.room}</TableCell>
                    <TableCell>{location.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.getLocationById(location.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ locationToDelete: location, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("locations")}
                    action={
                        selectedClient !== null && <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ clientToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_location")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="35%">{this.props.t("address")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("postal_code")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("city")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("country")}</TableCell>
                                                        <TableCell component="th" scope="row" width="5%">{this.props.t("floor")}</TableCell>
                                                        <TableCell component="th" scope="row" width="5%">{this.props.t("room")}</TableCell>
                                                        <TableCell component="th" scope="row" width="5%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {locationsList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateLocation
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                locationToEdit={locationToEdit ? locationToEdit : null}
                getLocations={() => this.getLocations(this.state.activePage, selectedClient.id)}
            />
            {
                locationToDelete && <ConfirmationDialog
                    isOpen={dialogOpen}
                    title={this.props.t("delete_location")}
                    message={this.props.t("delete_location_dialog_message", { address: locationToDelete.address })}
                    onClose={() => this.setState({ dialogOpen: false })}
                    onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteLocation())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Locations))